import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  /* width: 100%; */
  text-align: inherit;
  flex-shrink: 0;
`

const Calculated = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: inherit;
  color: #7f7f7f;
  line-height: 1.2;
  border-bottom: 1px solid #e0e0e0;
  min-width: 0;
`

const Input = styled.div<{ $isEdited?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: inherit;
  color: #262626;
  line-height: 1.2;
  min-width: 0;

  ${props =>
    props.$isEdited &&
    `
    background-color: rgba(255, 193, 7, 0.2);
  `}
`

export const SingleValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  padding-right: 8px;
`

interface DualValueCellProps {
  calculatedContent: React.ReactNode
  inputContent: React.ReactNode
  calculatedTitle?: string
  inputTitle?: string
  style?: React.CSSProperties
  isEdited?: boolean
}

export const DualValueCell: React.FC<DualValueCellProps> = ({
  calculatedContent,
  inputContent,
  calculatedTitle,
  inputTitle,
  style,
  isEdited
}) => {
  return (
    <Container style={style}>
      <Calculated title={calculatedTitle}>{calculatedContent}</Calculated>
      <Input title={inputTitle} $isEdited={isEdited}>
        {inputContent}
      </Input>
    </Container>
  )
}
